import { render } from "./FaultTypeChart.vue?vue&type=template&id=b2f85b52"
import script from "./FaultTypeChart.vue?vue&type=script&lang=js"
export * from "./FaultTypeChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__